/**
 * Survey module barrel export.
 *
 * Router integration — add this to the existing router.tsx as a child
 * of the `visits/:visitId` route:
 *
 *   import { surveyRoutes } from './pages/survey'
 *
 *   {
 *     path: 'visits/:visitId',
 *     children: [
 *       // ... existing children ...
 *       ...surveyRoutes,
 *     ],
 *   }
 */

import type { RouteObject } from 'react-router-dom'
import { SurveyDashboard } from './SurveyDashboard'
import { SurveyCapture } from './SurveyCapture'
import { SurveyFindings } from './SurveyFindings'
import { SurveyTracers } from './SurveyTracers'
import { SurveyDocuments } from './SurveyDocuments'
import { SurveyComplete } from './SurveyComplete'
import { SurveyWalkthrough } from './SurveyWalkthrough'
import { SurveyExitSummary } from './SurveyExitSummary'
import { SurveyCorrections } from './SurveyCorrections'
import { SurveyReport } from './SurveyReport'
import { PrestudyUpload } from './PrestudyUpload'

export const surveyRoutes: RouteObject[] = [
  {
    path: 'survey',
    children: [
      { index: true, element: <SurveyDashboard /> },
      { path: 'walkthrough', element: <SurveyWalkthrough /> },
      { path: 'capture', element: <SurveyCapture /> },
      { path: 'findings', element: <SurveyFindings /> },
      { path: 'tracers', element: <SurveyTracers /> },
      { path: 'documents', element: <SurveyDocuments /> },
      { path: 'complete', element: <SurveyComplete /> },
      { path: 'exit-summary', element: <SurveyExitSummary /> },
      { path: 'corrections', element: <SurveyCorrections /> },
      { path: 'report', element: <SurveyReport /> },
    ],
  },
  {
    path: 'prestudy',
    children: [
      { path: 'upload', element: <PrestudyUpload /> },
    ],
  },
]
